import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { normalize } from 'normalizr';
import { request } from 'utils';
import { FETCH_FINANCE_ORGANIZATIONS_REQUEST, FETCH_FINANCE_ORGANIZATIONS_SUCCESS, FETCH_FINANCE_ORGANIZATIONS_FAILURE, FETCH_FINANCE_ORGANIZATION_REQUEST, FETCH_FINANCE_ORGANIZATION_SUCCESS, FETCH_FINANCE_ORGANIZATION_FAILURE } from 'actionTypes';
import { getOrganizationsIsFetching, getOrganizationsIsLoaded, makeGetOrganization } from 'selectors';
import { organizations as organizationsSchema } from 'schemas';
import { PRODUCT_TYPE } from '../constants';
var getOrganization = makeGetOrganization();

var getShouldFetchOrganizations = function getShouldFetchOrganizations(state, props) {
  var isFetching = getOrganizationsIsFetching(state, props);
  var isLoaded = getOrganizationsIsLoaded(state, props);
  return !isFetching && !isLoaded;
};

export var fetchOrganizations = function fetchOrganizations(props) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var state, requestURL, _yield$request, data, url, fullOrganizationsData, _yield$request2, organizationsList, _normalize, _normalize$entities$o, entities, _normalize$result, ids;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              state = getState();

              if (getShouldFetchOrganizations(state, props)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", true);

            case 4:
              dispatch({
                type: FETCH_FINANCE_ORGANIZATIONS_REQUEST,
                payload: {}
              });
              requestURL = "".concat(process.env.APP_COMPANIES_API_ROOT, "?locale=").concat(props.intl.locale, "&type[]=bank");
              _context.next = 8;
              return request(requestURL);

            case 8:
              _yield$request = _context.sent;
              data = _yield$request.data;
              url = "".concat(process.env.APP_ORGANISATIONS_API_ROOT, "?active=1&product_type=").concat(PRODUCT_TYPE.rko);
              fullOrganizationsData = [];
              _context.prev = 12;
              _context.next = 15;
              return request(url);

            case 15:
              _yield$request2 = _context.sent;
              organizationsList = _yield$request2.data;
              fullOrganizationsData = data.map(function (item) {
                var index = organizationsList.findIndex(function (organization) {
                  return Number(item.id) === Number(organization.minfinId);
                });

                if (index !== -1) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    rkoCommercialOrderMinfin: organizationsList[index].rkoCommercialOrderMinfin
                  });
                }

                return item;
              });
              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](12);
              fullOrganizationsData = _toConsumableArray(data);
              console.log("error occurred while getting data from ".concat(url));

            case 24:
              _normalize = normalize(fullOrganizationsData, organizationsSchema), _normalize$entities$o = _normalize.entities.organizations, entities = _normalize$entities$o === void 0 ? {} : _normalize$entities$o, _normalize$result = _normalize.result, ids = _normalize$result === void 0 ? [] : _normalize$result;
              return _context.abrupt("return", dispatch({
                type: FETCH_FINANCE_ORGANIZATIONS_SUCCESS,
                payload: {
                  entities: entities,
                  ids: ids
                }
              }));

            case 28:
              _context.prev = 28;
              _context.t1 = _context["catch"](0);
              return _context.abrupt("return", dispatch({
                type: FETCH_FINANCE_ORGANIZATIONS_FAILURE,
                payload: {}
              }));

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 28], [12, 20]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getShouldFetchOrganization = function getShouldFetchOrganization(state, props) {
  var _getOrganization = getOrganization(state, props),
      isFetching = _getOrganization.isFetching,
      isLoaded = _getOrganization.isLoaded;

  return !isFetching && !isLoaded;
};

export var fetchOrganization = function fetchOrganization(props) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var state, organizationSlug, requestURL, _yield$request3, data, _organizationSlug;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              state = getState();

              if (getShouldFetchOrganization(state, props)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return", true);

            case 4:
              organizationSlug = props.params.organizationSlug;
              dispatch({
                type: FETCH_FINANCE_ORGANIZATION_REQUEST,
                payload: {
                  organizationSlug: organizationSlug,
                  isFetching: true
                }
              });
              requestURL = "".concat(process.env.APP_COMPANIES_API_V2_ROOT).concat(organizationSlug, "/?locale=").concat(props.intl.locale);
              _context2.next = 9;
              return request(requestURL);

            case 9:
              _yield$request3 = _context2.sent;
              data = _yield$request3.data;
              return _context2.abrupt("return", dispatch({
                type: FETCH_FINANCE_ORGANIZATION_SUCCESS,
                payload: {
                  organizationSlug: organizationSlug,
                  data: {
                    id: parseInt(data.financeId, 10) || 0,
                    minfinId: parseInt(data.id, 10) || 0,
                    slug: data.slug.toLowerCase(),
                    name: data.name,
                    nameG: data.nameG,
                    nameP: data.nameP,
                    fullLogo: data.fullLogo,
                    menu: data.menu,
                    backgroundImage: data.backgroundImage
                  }
                }
              }));

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](0);
              _organizationSlug = props.params.organizationSlug;
              return _context2.abrupt("return", dispatch({
                type: FETCH_FINANCE_ORGANIZATION_FAILURE,
                payload: {
                  organizationSlug: _organizationSlug
                }
              }));

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 14]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};